<template>
  <div class="room-interpreting-modal-component">
    <div class="room-interpreting-modal">
      <component :is="interpretingComponent" />
    </div>
  </div>
</template>

<script>
import RoomInterpretingInterpreter from '@/components/Room/Interpreting/Interpreter'
import RoomInterpretingSubscriber from '@/components/Room/Interpreting/Subscriber'

export default {
  name: 'RoomInterpretingModal',
  data() {
    return {
      interpreter: true
    }
  },
  computed: {
    interpretingComponent() {
      if (this.interpreter) {
        return RoomInterpretingInterpreter
      } else {
        return RoomInterpretingSubscriber
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.room-interpreting-modal-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  position: absolute;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3;
}
.room-interpreting-modal {
  width: 400px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 10px 30px rgb(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 6px;
  bottom: 6px;
}

// Mobile
[grm-device-mobile] {
  @media (max-width: 1024px) {
    .room-interpreting-modal-component {
      top: 50px;
      left: 60px;
    }
    .room-interpreting-modal {
      width: 100%;
      box-shadow: none;
      top: 0;
      bottom: 0;
    }
  }
}
</style>